// Per-gym lookup table.
//
// Phones, addresses, and slugs scraped from each gym's page on
// startingstrengthgyms.com (JSON-LD ExerciseGym block).
//
// Lytle Grove swag URLs were provided directly by the franchisor.
//
// Keys must match the gym_name string the dashboard API returns. The exact
// strings Pike13 emits in production may differ; if so, add aliases below or
// update the API to emit canonical names.
const GYM_DIRECTORY = {
  'Starting Strength Atlanta': {
    slug: 'atlanta',
    phone: '(470) 944-7715',
    address: '9775 Medlock Bridge Road, Suite K, Johns Creek, GA 30097',
    swagUrl: 'https://www.lytlegrove.com/SSAtlantaRetail',
    slackUrl: null, // PENDING from franchisor
  },
  'Starting Strength Austin - Sunset Valley': {
    slug: 'sunsetvalley',
    phone: '(512) 640-0950',
    address: '4970 US-290 W, Suite 410, Austin, TX 78735',
    swagUrl: 'https://www.lytlegrove.com/SSAustinSVRetail',
    slackUrl: 'https://join.slack.com/t/ssgymsaustin/shared_invite/zt-3weqx951c-GnoHScEPKxxgvHXoRXJLmw',
  },
  'Starting Strength Austin | W Anderson': {
    slug: 'w-anderson',
    phone: '(512) 766-4202',
    address: '2943 W Anderson Lane, Austin, TX 78757',
    swagUrl: 'https://www.lytlegrove.com/SSAustinWARetail',
    slackUrl: 'https://join.slack.com/t/ssgymsaustin/shared_invite/zt-3weqx951c-GnoHScEPKxxgvHXoRXJLmw',
  },
  'Starting Strength Beaverton': {
    slug: 'beaverton',
    phone: '(360) 207-1664',
    address: '4655 SW Griffith Dr, Suite 125, Beaverton, OR 97005',
    swagUrl: 'https://www.lytlegrove.com/SSBeavertonRetail',
    slackUrl: 'https://join.slack.com/t/ss-beaverton/shared_invite/zt-3vz437or7-QascOS30uelgu3LaHtWWgA',
  },
  'Starting Strength Birmingham': {
    slug: 'birmingham',
    phone: '(205) 905-8305',
    address: '1960 Braddock Dr. Suite 120, Hoover, AL 35216',
    swagUrl: 'https://www.lytlegrove.com/SSBirminghamRetail',
    slackUrl: 'https://join.slack.com/t/ssgyms-birmingham/shared_invite/zt-33uq2j3wg-~F21kwNh2~0HOkklKLRBfA',
  },
  'Starting Strength Boise | West': {
    slug: 'boise',
    phone: '(208) 219-5015',
    address: '13601 W. McMillan Rd, Suite A105, Boise, ID 83713',
    swagUrl: 'https://www.lytlegrove.com/SSBoiseWestRetail',
    slackUrl: null, // PENDING
  },
  'Starting Strength Boise | Downtown': {
    slug: 'boise-downtown',
    phone: '(208) 219-5917',
    address: '135 S Broadway Ave, Boise, ID 83702',
    swagUrl: 'https://www.lytlegrove.com/SSBoiseDowntownRetail',
    slackUrl: null, // PENDING
  },
  'Starting Strength Boston': {
    slug: 'boston',
    phone: '(617) 209-9796',
    address: '993 Watertown St, West Newton, MA 02465',
    swagUrl: 'https://www.lytlegrove.com/SSBostonRetail',
    slackUrl: 'https://join.slack.com/t/ssboston/shared_invite/zt-3w3p2tw90-7N7Ulct5bmw5z1yipDmvxQ',
  },
  'Starting Strength Brooklyn': {
    slug: 'brooklyn',
    phone: '(929) 345-3232',
    address: null,
    swagUrl: null,
    slackUrl: 'https://join.slack.com/t/ss-brooklyn/shared_invite/zt-3w0hai3gl-ZaQt2CIcp~iAhXL3a5iW3w',
  },
  'Starting Strength Chicago': {
    slug: 'chicago',
    phone: '(312) 448-6548',
    address: '2550 W Addison St, Suite A-18, Chicago, IL 60618-5952',
    swagUrl: 'https://www.lytlegrove.com/SSChicagoRetail',
    slackUrl: 'https://join.slack.com/t/sschicago/shared_invite/zt-3w664eiac-MPGiyUi31e~DwVqTlGt4kA',
  },
  'Starting Strength Cincinnati': {
    slug: 'cincinnati',
    phone: '(513) 201-7510',
    address: '7844-A Kingland Dr, West Chester Township, OH 45069',
    swagUrl: 'https://www.lytlegrove.com/SSCincinnatiRetail',
    slackUrl: 'https://join.slack.com/t/sscincinnati/shared_invite/zt-3w13rtveu-1vELpP5vzq9FXSj0QpRaEw',
  },
  'Starting Strength Colorado Springs': {
    slug: null,
    phone: null,
    address: null,
    swagUrl: 'https://www.lytlegrove.com/SSColoradoSpringsRetail',
    slackUrl: null, // PENDING
  },
  'Starting Strength Columbus': {
    slug: 'columbus',
    phone: '(614) 618-4868',
    address: '6083 Parkcenter Circle, Dublin, OH 43017',
    swagUrl: 'https://www.lytlegrove.com/SSColumbusRetail',
    slackUrl: 'https://join.slack.com/t/sscolumbus/shared_invite/zt-3vz4hj8jn-DEbfOKZ7ZfrU_DBCpgrnqg',
  },
  'Starting Strength Dallas': {
    slug: 'dallas',
    phone: '(214) 466-1996',
    address: '6109-B Greenville Ave, Dallas, TX 75206',
    swagUrl: 'https://www.lytlegrove.com/SSDallasRetail',
    slackUrl: 'https://join.slack.com/t/ssgymsdallas/shared_invite/zt-3w0hl20ut-SpRiKsrAAn2~zsIzC8BxkQ',
  },
  'Starting Strength Denver | Centennial': {
    slug: 'centennial',
    phone: '(720) 709-1453',
    address: '8214 S Holly St, Centennial, CO 80122',
    swagUrl: 'https://www.lytlegrove.com/SSDenverCentennialRetail',
    slackUrl: 'https://join.slack.com/t/ssgymsdenver/shared_invite/zt-3w2wy9qdh-usFYrjFtXBh~sh_AUcOA_Q',
  },
  'Starting Strength Houston': {
    slug: 'houston',
    phone: '(713) 364-2381',
    address: '3701 S Shepherd Drive, Suite B, Houston, TX 77098',
    swagUrl: 'https://www.lytlegrove.com/SSHoustonRetail',
    slackUrl: 'https://join.slack.com/t/startingstrengthhou/shared_invite/zt-3w64w5cis-8sVJCWCzLjbtCUx4FmTeWA',
  },
  'Starting Strength Indianapolis': {
    slug: 'indianapolis',
    phone: '(463) 240-6286',
    address: '8510 E 96th St, Suite G, Fishers, IN 46038',
    swagUrl: 'https://www.lytlegrove.com/SSIndianapolisRetail',
    slackUrl: 'https://join.slack.com/t/ss-indianapolis/shared_invite/zt-3x3rtavo6-avEVR0UOpk1DXMgRFNDRLQ',
  },
  'Starting Strength Katy': {
    slug: 'katy',
    phone: '(713) 804-6173',
    address: '1230 N Mason Rd, Suite 550, Katy, TX 77449',
    swagUrl: 'https://www.lytlegrove.com/SSKatyRetail',
    slackUrl: 'https://join.slack.com/t/startingstrengthkaty/shared_invite/zt-3x6cpjksk-1m7GSaTo19rJL4u~khJndw',
  },
  'Starting Strength Long Island': {
    slug: 'longisland',
    phone: null,
    address: null,
    swagUrl: 'https://www.lytlegrove.com/SSLongIslandRetail',
    slackUrl: 'https://join.slack.com/t/ss-long-island/shared_invite/zt-3whh8nr40-3sipxTWSAiL~WmSv8YstJA',
  },
  'Starting Strength Memphis': {
    slug: 'memphis',
    phone: '(901) 209-9662',
    address: '7850 Poplar Ave, Suite 50-28, Germantown, TN 38138',
    swagUrl: 'https://www.lytlegrove.com/SSMemphisRetail',
    slackUrl: 'https://join.slack.com/t/ssmemphis/shared_invite/zt-3w66wzc38-YJLH2_roe_wyIojU3ZU7ww',
  },
  'Starting Strength Miami': {
    slug: 'miami',
    phone: '(786) 755-3259',
    address: '8400 S Dixie Hwy, Suite 102, Miami, FL 33143',
    swagUrl: 'https://www.lytlegrove.com/SSMiamiRetail',
    slackUrl: 'https://join.slack.com/t/startingstrengthmiami/shared_invite/zt-3w1kas3ab-XuIfFzf4fvPim4LTFunbMA',
  },
  'Starting Strength Nashville': {
    slug: 'nashville',
    phone: '(629) 249-6344',
    address: null,
    swagUrl: null,
    slackUrl: 'https://join.slack.com/t/ss-nashville/shared_invite/zt-2tcqjxllu-_KVk15tEniJOkn~9cQwIuQ',
  },
  'Starting Strength Oklahoma City': {
    slug: null,
    phone: null,
    address: null,
    swagUrl: 'https://www.lytlegrove.com/SSOKCRetail',
    slackUrl: 'https://join.slack.com/t/ssgymsokc/shared_invite/zt-3sxwk3oqc-oOgk3t_8Vp5NX8yo5BKzwg',
  },
  'Starting Strength Omaha': {
    slug: 'omaha',
    phone: '(402) 769-3030',
    address: '539 N 155th Plaza, Omaha, NE 68154',
    swagUrl: 'https://www.lytlegrove.com/SSOmahaRetail',
    slackUrl: 'https://join.slack.com/t/startingstrengthomaha/shared_invite/zt-3x6cvpbb8-v0e1bP9OB8gBVOfQ9B4LOw',
  },
  'Starting Strength Orlando': {
    slug: 'orlando',
    phone: '(407) 490-4194',
    address: '437 S Orlando Ave, Maitland, FL 32751',
    swagUrl: 'https://www.lytlegrove.com/SSOrlandoRetail',
    slackUrl: 'https://join.slack.com/t/ssorlando/shared_invite/zt-3wxly25t3-UM7xuYIc8sApTdvt~13i~A',
  },
  'Starting Strength Philadelphia': {
    slug: 'philadelphia',
    phone: '(215) 826-3266',
    address: '339 East Lancaster Ave, Unit #7, Wynnewood, PA 19096',
    swagUrl: 'https://www.lytlegrove.com/SSPhiladelphiaRetail',
    slackUrl: 'https://join.slack.com/t/ss-philly/shared_invite/zt-36o9ifrc7-mROSlPhiUzOi5325gxUwig',
  },
  'Starting Strength Plano': {
    slug: 'plano',
    phone: '(469) 731-8687',
    address: '8240 Preston Rd, Suite 120, Plano, TX 75024',
    swagUrl: 'https://www.lytlegrove.com/SSPlanoRetail',
    slackUrl: 'https://join.slack.com/t/startingstrengthplano/shared_invite/zt-3whixemvk-R5_7KjtupWbDC8ZqxpJivg',
  },
  'Starting Strength Raleigh': {
    slug: 'raleigh',
    phone: '(984) 205-7272',
    address: null,
    swagUrl: 'https://www.lytlegrove.com/SSRaleighRetail',
    slackUrl: 'https://join.slack.com/t/ss-raleigh/shared_invite/zt-3w1kpj60z-YsYTLEqTXm0pTrejEFh1bQ',
  },
  'Starting Strength San Antonio': {
    slug: 'sanantonio',
    phone: '(210) 806-7311',
    address: '19739 IH-10 West, Suite 104, San Antonio, TX 78256',
    swagUrl: 'https://www.lytlegrove.com/SSSanAntonioRetail',
    slackUrl: 'https://join.slack.com/t/ssgymssanantonio/shared_invite/zt-3w4j97snm-wKfta97esm0V53aV5xJJGA',
  },
  'Starting Strength Scottsdale': {
    slug: 'scottsdale',
    phone: '(602) 610-1196',
    address: '8912 E. Via Linda, Ste. 120, Scottsdale, AZ 85258',
    swagUrl: 'https://www.lytlegrove.com/SSScottsdaleRetail',
    slackUrl: 'https://join.slack.com/t/ss-scottsdale/shared_invite/zt-3w692z2wx-Ndmch2xS5QDLlCZXx9DzEg',
  },
  'Starting Strength St. Louis': {
    slug: 'stlouis',
    phone: '(314) 742-9922',
    address: "2506 Highway K, O'Fallon, MO 63366",
    swagUrl: 'https://www.lytlegrove.com/SSStLouisRetail',
    slackUrl: 'https://join.slack.com/t/ss-stlouis/shared_invite/zt-3xam2ba75-CAg3fIHeqQ7a56fySYLN0w',
  },
  'Starting Strength Tulsa': {
    slug: 'tulsa',
    phone: '(539) 233-1627',
    address: '9168 S Yale Ave, Suite 130, Tulsa, OK 74137',
    swagUrl: 'https://www.lytlegrove.com/SSTulsaRetail',
    slackUrl: 'https://join.slack.com/t/startingstrengthtulsa/shared_invite/zt-347v3fz9z-~uOZDN7ZIDHAoRUnMj0E8g',
  },
};

// Common alias variants — extend as we discover the exact gym_name strings
// emitted by the dashboard API in production.
const GYM_ALIASES = {
  'Starting Strength Austin': 'Starting Strength Austin - Sunset Valley',
  'Starting Strength Boise': 'Starting Strength Boise | West',
  'Starting Strength Denver': 'Starting Strength Denver | Centennial',
};

const resolveGym = (gymName) => {
  if (!gymName) return null;
  if (GYM_DIRECTORY[gymName]) return GYM_DIRECTORY[gymName];
  const aliasTarget = GYM_ALIASES[gymName];
  if (aliasTarget && GYM_DIRECTORY[aliasTarget]) return GYM_DIRECTORY[aliasTarget];
  return null;
};

export const getGymPhone = (gymName) => {
  const gym = resolveGym(gymName);
  return gym ? gym.phone : null;
};

export const getGymSwagUrl = (gymName) => {
  const gym = resolveGym(gymName);
  return gym ? gym.swagUrl : null;
};

export const getGymSiteUrl = (gymName) => {
  const gym = resolveGym(gymName);
  return gym && gym.slug ? `https://www.startingstrengthgyms.com/${gym.slug}/` : null;
};

export const getGymSlackUrl = (gymName) => {
  const gym = resolveGym(gymName);
  return gym ? gym.slackUrl : null;
};

// Without a Google place_id we use a Maps search URL — opens to the business
// card with a "Write a review" button one tap away.
export const getGoogleReviewUrl = (gymName) => {
  if (!gymName) return 'https://www.google.com/maps/';
  return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(gymName)}`;
};
